import React, { PropsWithChildren } from "react";
import { InvoiceCreateContextState } from "models/propTypes/invoicePropTypes";
import { ContextConstants } from "utils/constants";
import { InvoiceCreateReducer } from "./reducer";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

const initialState: InvoiceCreateContextState = {
  invoiceHtml: undefined,
  invoiceDate: new Date(),
  deliveryDate: new Date(),
  recurringStartDate: new Date(),
  setInvoiceHtml: (content: string) => {},
  setInvoiceDate: (date?: Date) => {},
  setDeliveryDate: (date?: Date) => {},
  setRecurringStartDate: (date?: Date) => {},
  setRecurringFrequency: (value?: WintSuperkollAPIModel.RecurringInvoiceFrequency) => {},
};

export const InvoiceCreateContext = React.createContext<InvoiceCreateContextState>(initialState);

const InvoiceCreateContextProvider: React.FC<PropsWithChildren> = (props) => {
  const [state, dispatch] = React.useReducer(InvoiceCreateReducer, initialState);

  const setInvoiceHtml = (content: string) => {
    dispatch({ type: ContextConstants.InvoiceActions.SET_INVOICE_HTML, payload: content });
  };

  const setInvoiceDate = (date?: Date) => {
    if (
      (date === undefined && state.invoiceDate === undefined) ||
      (date && state.invoiceDate && new Date(date).getTime() === new Date(state.invoiceDate).getTime())
    )
      return;
    dispatch({ type: ContextConstants.InvoiceActions.SET_INVOICE_DATE, payload: date });
  };

  const setDeliveryDate = (date?: Date) => {
    if (
      (date === undefined && state.deliveryDate === undefined) ||
      (date && state.deliveryDate && new Date(date).getTime() === new Date(state.deliveryDate).getTime())
    )
      return;

    dispatch({ type: ContextConstants.InvoiceActions.SET_DELIVERY_DATE, payload: date });
  };

  const setRecurringStartDate = (date?: Date) => {
    if (
      (date === undefined && state.recurringStartDate === undefined) ||
      (date && state.recurringStartDate && new Date(date).getTime() === new Date(state.recurringStartDate).getTime())
    )
      return;
    dispatch({ type: ContextConstants.InvoiceActions.SET_RECURRING_START_DATE, payload: date });
  };

  const setRecurringFrequency = (value?: WintSuperkollAPIModel.RecurringInvoiceFrequency) => {
    if (value === state.recurringFrequency) return;
    dispatch({ type: ContextConstants.InvoiceActions.SET_RECURRING_FREQUENCY, payload: value });
  };

  return (
    <InvoiceCreateContext.Provider
      value={{
        ...state,
        setInvoiceHtml,
        setInvoiceDate,
        setDeliveryDate,
        setRecurringStartDate,
        setRecurringFrequency,
      }}
    >
      {props.children}
    </InvoiceCreateContext.Provider>
  );
};

export default InvoiceCreateContextProvider;
